import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Modal, View, StyleSheet, TouchableOpacity } from 'react-native';
import { CancelButtonIcon, getTestId } from '@airtel/air-design-system';
import { withBoundaries } from '../../hoc';
import { getFullPageSectionStyles } from './FullPageSectionStyles';
var FullPageSectionComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'FullPageSection' : _props$testID,
    children = props.children,
    _props$showBackdrop = props.showBackdrop,
    showBackdrop = _props$showBackdrop === void 0 ? true : _props$showBackdrop,
    dismissDuration = props.dismissDuration,
    _props$isVisible = props.isVisible,
    isVisible = _props$isVisible === void 0 ? true : _props$isVisible,
    _props$showCrossButto = props.showCrossButton,
    showCrossButton = _props$showCrossButto === void 0 ? false : _props$showCrossButto,
    style = props.style,
    onDismissMetaData = props.onDismissMetaData,
    onUserAction = props.onUserAction;
  if (!isVisible) return null;
  var fullPageSectionStyles = getFullPageSectionStyles(props);
  var _useState = useState(true),
    visible = _useState[0],
    setVisible = _useState[1];
  useEffect(() => {
    if (dismissDuration > 0) {
      setTimeout(() => {
        setVisible(false);
      }, dismissDuration);
    }
  }, [dismissDuration]);
  useEffect(() => {
    setVisible(isVisible);
  }, [isVisible]);
  var handleClose = () => {
    setVisible(false);
    onDismissMetaData && onUserAction(Object.assign({
      id
    }, onDismissMetaData), props);
  };
  return _jsxs(Modal, Object.assign({
    visible: visible,
    animationType: "none",
    presentationStyle: "overFullScreen",
    transparent: true
  }, getTestId(testID), {
    onDismiss: () => {
      onDismissMetaData && onUserAction(Object.assign({
        id
      }, onDismissMetaData), props);
    },
    style: style
  }, {
    children: [showBackdrop && _jsx(View, {
      style: [StyleSheet.absoluteFill, fullPageSectionStyles.backdrop]
    }), _jsx(View, Object.assign({
      style: fullPageSectionStyles.children
    }, {
      children: _jsxs(View, {
        children: [children, showCrossButton && _jsx(TouchableOpacity, Object.assign({
          onPress: handleClose,
          style: fullPageSectionStyles.closeButton
        }, getTestId(testID + 'crossButton'), {
          children: _jsx(CancelButtonIcon, {
            fontSize: 24
          })
        }))]
      })
    }))]
  }));
};
FullPageSectionComponent.genericRendererKey = 'AirFullPageSection';
FullPageSectionComponent.isAirSection = true;
export var FullPageSection = withBoundaries(FullPageSectionComponent);